function isSupportQuerySelector(property) {
  return property.substr(0, 9) === '@supports';
}
export { isSupportQuerySelector };